import React from "react";

import { Helmet } from "react-helmet";
import { useAuth } from "../../../Store/AuthContext";
import Sidebar from "../Sidebar";
import DeshbordBreadcrumb from "../Breadcrumb/DeshbordBreadcrumb";
import DeshBoardFooter from "../DeshBoardFooter";
import WalletTransactionDataTable from "./WalletTransactionDataTable";

export default function WalletTransactions() {
  const { RendomTokenfetch } = useAuth();

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow"></meta>
      </Helmet>
      <div className="page-wrapper dashboard mm-page mm-slideout" id="mm-0">
        <Sidebar />
        <DeshbordBreadcrumb
          page1={[
            { name: "Passbook", pagelink: "passbook" },
            { name: "Wallet Transactions" },
          ]}
        />

        <section className="user-dashboard">
          <div className="dashboard-outer">
            {RendomTokenfetch && <WalletTransactionDataTable />}
          </div>
        </section>

        <div className="deshboard_footer">
          <DeshBoardFooter />
        </div>
      </div>
    </>
  );
}
